import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import Dashboard from "../pages/Dashboard";
import NotFound from "../pages/NotFound";
import ComingSoon from "../pages/ComingSoon";
import ResetPassword from "../pages/ResetPassword";

import PrivateRoute from "./PrivateRoute";
import DashboardLayout from "../layouts/DashboardLayout";

import FleetOverview from "../pages/Fleet/FleetOverview";
import FleetEmission from "../pages/Fleet/FleetEmission";
import FleetPerformance from "../pages/Fleet/FleetPerformance";

import VesselOverview from "../pages/Vessel/VesselOverview";
import VesselEmission from "../pages/Vessel/VesselEmission";
import VesselPerformance from "../pages/Vessel/VesselPerformance";
import VesselMachinery from "../pages/Vessel/VesselMachinery";
import VesselDataQuality from "../pages/Vessel/VesselDataQuality";

import ComplianceOverview from "../pages/Compliance/ComplianceOverview";
import EUETS from "../pages/Compliance/EUETS";
import CII from "../pages/Compliance/CII";
import FuelEU from "../pages/Compliance/FuelEU";
import EUMRV from "../pages/Compliance/EUMRV";
import UKMRV from "../pages/Compliance/UKMRV";
import IMODCS from "../pages/Compliance/IMODCS";
import UKETS from "../pages/Compliance/UKETS";
import AdditivesPerformance from "../pages/Compliance/AdditivesPerformance";

import UserManagement from "../pages/Admin/UserManagement";
import CompanyManagement from "../pages/Admin/CompanyManagement";
import FleetManagement from "../pages/Admin/FleetManagement";
import VesselManagement from "../pages/Admin/VesselManagement";
import ExcelManagement from "../pages/Admin/ExcelManagement";
import ReferencePage from "../pages/Admin/ReferencePage";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/fleet-overview" />} />
      <Route path="/login" element={<Login />} />

      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      {/* Protected Routes */}
      <Route element={<PrivateRoute />}>
        {/* Dashboard Layout wraps all private pages */}
        <Route element={<DashboardLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/fleet-overview" element={<FleetOverview />} />
          <Route path="/fleet/fleet-emission" element={<FleetEmission />} />
          <Route
            path="/fleet/fleet-performance"
            element={<FleetPerformance />}
          />

          <Route path="/vessel-overview" element={<VesselOverview />} />
          <Route path="/vessel/vessel-emission" element={<VesselEmission />} />
          <Route
            path="/vessel/vessel-performance"
            element={<VesselPerformance />}
          />
          <Route
            path="/vessel/vessel-machinery"
            element={<VesselMachinery />}
          />
          <Route
            path="/vessel/vessel-data-quality"
            element={<VesselDataQuality />}
          />

          <Route path="/compliance-overview" element={<ComplianceOverview />} />
          <Route path="/compliance/eu-ets" element={<EUETS />} />
          <Route path="/compliance/cii" element={<CII />} />
          <Route path="/compliance/fuel-eu" element={<FuelEU />} />
          <Route path="/compliance/eu-mrv" element={<EUMRV />} />
          <Route path="/compliance/uk-mrv" element={<UKMRV />} />
          <Route path="/compliance/imo-dcs" element={<IMODCS />} />
          {/* <Route path="/compliance/uk-ets" element={<UKETS />} /> */}
          <Route path="/compliance/uk-ets" element={<ComingSoon />} />
          <Route
            path="/compliance/additiveperformance"
            element={<AdditivesPerformance />}
          />

          {/* Admin Panel */}
          <Route path="/admin/user-management" element={<UserManagement />} />
          <Route
            path="/admin/company-management"
            element={<CompanyManagement />}
          />
          <Route path="/admin/fleet-management" element={<FleetManagement />} />
          <Route
            path="/admin/vessel-management"
            element={<VesselManagement />}
          />
          <Route path="/admin/excel-management" element={<ExcelManagement />} />

          <Route path="/admin/reference" element={<ReferencePage />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
